<template>
    <div>
        <b-form-group
            id="input-group-1"
            :label="field.label"
            :label-for="`id_${field._id}`"
        >
            <multiselect
                v-model="model"
                :placeholder="field.placeholder"
                :options="options"
                :label="textField"
                :track-by="valueField"
                :multiple="true"
                :taggable="false"
                @tag="addTag"
            ></multiselect>
        </b-form-group>
    </div>
</template>

<script>
import List from './List.vue'
import multiselect from 'vue-multiselect'
export default {
    // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        multiselect,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: List,

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            textField: 'title',
            valueField: 'code',
            options: [],
        }
    }, // End of Component > data

    methods: {
        addTag(newTag) {
            const tag = {
                name: newTag,
                code:
                    newTag.substring(0, 2) +
                    Math.floor(Math.random() * 10000000),
            }
            this.options.push(tag)
            this.value.push(tag)
        },
    },
}
</script>
